export const HOME_PAGE_V2_HOME_PATH = '/home';
export const HOME_PAGE_V2_CHAT_PATH = '/chat/index';
export const HOME_PAGE_V2_AI_DETECTOR_PATH = '/tools/ai_content_detector';
export const HOME_PAGE_V2_HUMANIZER_PATH = '/tools/ai_text_humanizer';
export const HOME_PAGE_V2_PLAGIARISM_PATH = '/tools/plagiarism_checker';
